import {autoloadingFormEdited} from "../../actions/schemaActions";

const onFormEdit = (property, newValue, component) => {
  component.props.dispatch(autoloadingFormEdited(component.props.id, property, newValue));
};

export default onFormEdit;